'use client';

import { DYBInterstitial } from '@/app/components/site-wide-jackpot/how-it-works/dyb-interstitial';
import { useStore } from '@/store/store';
import type { Tutorial } from '@/app/components/site-wide-jackpot/how-it-works/types';
import type { SiteWideJackpotSlicePrimary } from '@/types/zones/slices/site-wide-jackpot-slice';
import { usePopupBehavior } from '@/hooks/use-popup-behavior';
import type { InteractionType } from '@/tracking/amplitude/events/general/exclusives';
import { trackJackpotsEvent } from '@/tracking/amplitude/events/general/jackpots';

type DYBInterstitialPopupProps = {
    params: {
        tutorial?: Tutorial | null;
        logoUrl?: string;
        swjCategory?: SiteWideJackpotSlicePrimary['category'];
        isSWJTutorialV2?: boolean;
    };
};

export const DYBInterstitialPopup: React.FC<DYBInterstitialPopupProps> = ({ params }) => {
    const { sendEvent } = useStore((state) => state.tracking);

    const handleCloseModalTracking = (interactionType: InteractionType) => {
        const trackingData = trackJackpotsEvent('jackpotsIntroClosed', {
            interactionType
        });
        sendEvent([trackingData.event]);
    };

    const { popupRef, fade, handleAnimationEnd, handleClose, fadeOutAndClose } = usePopupBehavior(
        undefined,
        (interactionType) => handleCloseModalTracking(interactionType)
    );

    return (
        <DYBInterstitial
            onClose={handleClose}
            onCloseWithoutTracking={fadeOutAndClose}
            popupRef={popupRef}
            fade={fade}
            onAnimationEnd={handleAnimationEnd}
            tutorial={params.tutorial}
            logoUrl={params.logoUrl}
            swjCategory={params.swjCategory}
            isSWJTutorialV2={params.isSWJTutorialV2}
        />
    );
};
